import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgModelLlm = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.9893 8.66699H16.6875V4H19.3125V8.66699H22.0107V4H24.6357V8.66699H25.1924C26.3746 8.6672 27.3328 9.62544 27.333 10.8076V11.3643H32V13.9893H27.333V16.7236H32V19.3486H27.333V22.083H32V24.708H27.333V25.1924C27.3328 26.3746 26.3745 27.3338 25.1924 27.334H24.6357V32H22.0107V27.334H19.3125V32H16.6875V27.334H13.9893V32H11.3643V27.334H10.8076C9.6253 27.334 8.66717 26.3747 8.66699 25.1924V24.708H4V22.083H8.66699V19.3486H4V16.7236H8.66699V13.9893H4V11.3643H8.66699V10.8076C8.66716 9.62533 9.6253 8.66703 10.8076 8.66699H11.3643V4H13.9893V8.66699ZM11 25H25V11H11V25Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgModelLlm);
export { ForwardRef as ReactComponent };
